module.exports = __webpack_public_path__ + "img/content-1.66f781a1.png";